import { Route } from '@angular/router';
import { HistoryProjectComponent } from '@projects';

export const appRoutes: Route[] = [
  {
    path: '',
    title: 'History',
    component: HistoryProjectComponent
  }
];
